import { createAction, props } from "@ngrx/store";

export const FETCH_CLASS_TYPE_LIST = createAction(
    'FETCHCLASSTYPELIST',
    props<{ classTypes: any }>()
);